import gql from 'graphql-tag';

/**
 * Save changes to an existing named view
 */
export const saveNamedViewMutation = gql`
  mutation SaveNamedView($input: SaveNamedViewInput!) {
    saveNamedView(input: $input) {
      status
      viewName
      message
    }
  }
`;

/**
 * Create a new named view
 */
export const createViewMutation = gql`
  mutation CreateView($input: CreateViewInput!) {
    createView(input: $input) {
      status
      viewName
      message
    }
  }
`;

/**
 * Delete a named view
 */
export const deleteViewMutation = gql`
  mutation DeleteView($moduleName: String!, $viewName: String!) {
    deleteView(moduleName: $moduleName, viewName: $viewName) {
      status
      message
    }
  }
`;

/**
 * Rename an existing view
 */
export const renameViewMutation = gql`
  mutation RenameView($moduleName: String!, $oldName: String!, $newName: String!) {
    renameView(moduleName: $moduleName, oldName: $oldName, newName: $newName) {
      status
      newName
      message
    }
  }
`;

/**
 * Set the last-used view for tracking purposes.
 * Called when user switches views without saving.
 * Pass null for viewName to indicate Default View.
 */
export const setLastUsedViewMutation = gql`
  mutation SetLastUsedView($moduleName: String!, $viewName: String) {
    setLastUsedView(moduleName: $moduleName, viewName: $viewName) {
      status
      viewName
      message
    }
  }
`;
